<template>
  <div>
    <vs-card class="cstm_vx_card">
      <!-- {{localvalue}} -->
      <!-- {{errors}} -->
      <!-- {{value}} -->
      <vs-row vs-justify="space-between" slot="header">
        <h4>Availability</h4>
        <vs-button
          v-if="checkEditPermission()"
          type="border"
          color="primary"
          style="font-size: 13.8px; padding: 7px; float: right"
          @click="addpopup = true"
        >
          Edit
        </vs-button>
      </vs-row>
      <div class="vx-row">
        <vs-table :data="availabilityProps" class="cstm_vuexy_table w-full">
          <template slot="thead">
            <vs-th sort-key="name">Day</vs-th>
            <vs-th sort-key="date">Start time</vs-th>
            <vs-th sort-key="type">End time</vs-th>
            <!-- <vs-th sort-key="type" style="width: 100px">Day Off</vs-th> -->
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(item, indextr) in data">
              <vs-td :data="data[indextr].day">
                {{ data[indextr].day }}
              </vs-td>

              <vs-td :data="data[indextr].available_from">
                <span>{{
                  data[indextr].available_from | OnlytimeFormatLocalization
                }}</span>
              </vs-td>

              <vs-td :data="data[indextr].available_to">
                <span>{{
                  data[indextr].available_to | OnlytimeFormatLocalization
                }}</span>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vs-card>

    <vs-popup
      classContent="popup-example"
      title="Delete"
      :active.sync="deletepopup"
    >
      <h4>Are you sure to delete this ?</h4>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click="handleDelete">Confirm</vs-button>
        <vs-button type="border" color="danger" @click="deletepopup = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>

    <vs-popup
      classContent="popup-example"
      title="Availability"
      :active.sync="addpopup"
    >
      <a style="cursor: pointer; font-weight: 500" @click="addNewAvailability"
        >Add New Availability</a
      >
      <form data-vv-scope="add">
        <vs-row
          vs-type="flex"
          vs-align="center"
          class="p-1"
          v-for="(eachAvailability, index) in formAvailability"
          :key="index"
        >
          <vs-col class="p-1" vs-xs="12" vs-sm="12" vs-lg="5">
            <v-select :options="days" v-model="eachAvailability.day">
            </v-select>
            <!-- <a>{{ eachAvailability.day }}</a> -->
          </vs-col>
          <vs-col class="p-1" vs-xs="12" vs-sm="5" vs-lg="3">
            <flat-pickr
              v-validate="eachAvailability.holiday ? '' : 'required'"
              :name="`from${index}`"
              :config="{
                enableTime: true,
                enableSeconds: false,
                noCalendar: true,
                maxTime: eachAvailability.available_to,
              }"
              v-model="eachAvailability.available_from"
              placeholder="Start time"
              class="w-full"
            />
            <span v-show="errors.has(`add.from${index}`)" class="text-danger">{{
              errors.first(`add.from${index}`) | formatRequiredFieldText
            }}</span>
          </vs-col>
          <vs-col class="p-1" vs-xs="12" vs-sm="5" vs-lg="3">
            <flat-pickr
              v-validate="eachAvailability.holiday ? '' : 'required'"
              :name="`to${index}`"
              :config="{
                enableTime: true,
                enableSeconds: false,
                noCalendar: true,
                minTime: eachAvailability.available_from,
              }"
              v-model="eachAvailability.available_to"
              placeholder="End time"
              class="w-full"
            />
            <span v-show="errors.has(`add.to${index}`)" class="text-danger">{{
              errors.first(`add.to${index}`) | formatRequiredFieldText
            }}</span>
          </vs-col>
          <vs-col
            class="p-1 inline-flex justify-end"
            vs-xs="12"
            vs-sm="2"
            vs-lg="1"
          >
            <vs-button
              color="danger"
              type="border"
              @click="removeTime(index)"
              icon="delete"
            ></vs-button>
          </vs-col>
          <vs-divider />
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleSave">Save</vs-button>
        <vs-button type="border" color="danger" @click="addpopup = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { TeacherUpdate } from '@/api/teacher'

import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
export default {
  name: 'email',
  components: {
    flatPickr,
    vSelect
  },
  filters: {
    formatRequiredFieldText (message = '') {
      return message.replace(/\d/g, '')
    }
  },
  created () {
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission == 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Teachers')
    }
  },
  mixins: [PermissionMiddleware],
  props: {
    availabilityProps: {
      required: true,
      type: Array,
      default: () => []
    }
    /* value: {
      required: true,
      type: Array,
      default: () => []
    } */
  },
  data () {
    return {
      addpopup: false,
      deletepopup: false,
      editpopup: false,

      days: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
      ],
      /*   availability: [
        {
          day: 'Sunday',
          available_from: null,
          available_to: null,
          holiday: true
        },
        {
          day: 'Monday',
          available_from: null,
          available_to: null,
          holiday: true
        },
        {
          day: 'Tuesday',
          available_from: null,
          available_to: null,
          holiday: true
        },
        {
          day: 'Wednesday',
          available_from: null,
          available_to: null,
          holiday: true
        },
        {
          day: 'Thursday',
          available_from: null,
          available_to: null,
          holiday: true
        },
        {
          day: 'Friday',
          available_from: null,
          available_to: null,
          holiday: true
        },
        {
          day: 'Saturday',
          available_from: null,
          available_to: null,
          holiday: true
        }
      ], */
      edit: {
        day: null,
        available_from: null,
        available_to: null
      },
      editIndex: null,
      deleteindex: false,
      formAvailability: []
    }
  },
  mounted () {
    this.availabilityProps = this.availabilityProps.map((ele) => {
      return {
        ...ele,
        available_from: ele.available_from.substring(
          0,
          ele.available_from.length - 3
        ),
        available_to: ele.available_to.substring(
          0,
          ele.available_to.length - 3
        )
      }
    })
  },
  watch: {
    availabilityProps: {
      deep: true,
      immediate: true,
      handler () {
        this.formAvailability = this._.cloneDeep(this.availabilityProps)
      }
    }
  },
  methods: {
    removeTime (index) {
      this.formAvailability.splice(index, 1)
    },
    async handleSave () {
      this.$validator.validateAll('add').then((result) => {
        if (result) {
          this.handleAvailabilitysave()
        }
      })
    },
    async handleAvailabilitysave () {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const newArray = []
        this.formAvailability.forEach((item) => {
          const newItem = {}
          newItem.available_from = `${item.available_from  }:00`
          newItem.available_to = `${item.available_to  }:00`
          newItem.day = item.day
          newArray.push(newItem)
        })
        const payload = {
          updateField: {
            availability: newArray
          }
        }
        const { data } = await TeacherUpdate(
          payload,
          this.$route.params.teacher_id,
          customer_id
        )
        // this.setAfterUpdate(data)
        this.$emit('setAfterUpdate', data)
        // this.fetchTeacherDetails(this.$route.params.teacher_id)
        // this.bioEditPopup = false
        this.showSuccessMessage('Success', 'Updated Successfully', 'success')
      } catch (error) {
        this.showSuccessMessage('Error', error.data.message, 'danger')
      }
    },
    handleedit (index) {
      //
      this.editpopup = true

      this.edit = this.localvalue[index]
      this.editIndex = index
    },
    handleUpdateAvailiblity () {
      this.$validator.validateAll('edit').then((result) => {
        if (result) {
          this.localvalue[this.editIndex] = this.edit
          this.editpopup = false
        }
      })
    },
    handleDelete () {
      this.localvalue.splice(this.deleteindex, 1)
      this.deletepopup = false
    },
    remove (index) {
      this.deletepopup = true
      this.deleteindex = index
    },
    addNewAvailability () {
      const start_day = JSON.parse(
        localStorage.getItem('localization')
      ).start_day_id
      this.formAvailability.push({
        day: start_day === 0 ? 'Sunday' : 'Monday',
        available_from: null,
        available_to: null
      })
    }
  }
}
</script>
